import { render } from "./Preloader.vue?vue&type=template&id=d35b66bc"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=d35b66bc&lang=sass"
script.render = render

export default script